import Vue from 'vue'
import VueRouter from 'vue-router'

import { isUserLoggedIn, checkAccessible, checkWebVersion } from '@/auth/utils'
import apps from './routes/apps'
import pages from './routes/pages'
import desk from './routes/desk'
import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    if (document.querySelector('section.sub-wrap')) document.querySelector('section.sub-wrap').scrollTo(0, 0)
    if (document.querySelector('section.main-wrap')) document.querySelector('section.main-wrap').scrollTo(0, 0)
    if (document.querySelector('#container')) document.querySelector('#container').scrollTo(0, 0)

    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'app-main' } },
    ...apps,
    ...pages,
    ...desk,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

let cachedAppVersion = null
// eslint-disable-next-line consistent-return
router.beforeEach(async (to, _, next) => {
  if (to.name === 'app-preview' || to.name === 'app-preview-survey') {
    return next()
  }

  // ====================================================================================
  // App 버전과 User Web 버전이 일치하지 않으면 업데이트 가이드 페이지로 이동
  // ====================================================================================
  if (cachedAppVersion === null) {
    if (process.env && process.env.NODE_ENV === 'development' && process.env.VUE_APP_LOCAL_ENV) {
      cachedAppVersion = process.env.VUE_APP_VERSION_DRINFO
    } else {
      try {
        if (window.CefSharp && window.CefSharp.BindObjectAsync) {
          await window.CefSharp.BindObjectAsync("appConfig")
          cachedAppVersion = await window.appConfig.getVersion()
        }
      } catch (error) {
        cachedAppVersion = null
      }
    // cachedAppVersion = await checkAppVersion()
    }
  }
  const appVersion = cachedAppVersion
  const webVersion = await checkWebVersion()

  // alert(`App Version: ${appVersion}, Web Version: ${webVersion}`)
  if (appVersion !== webVersion && to.name !== 'error-503') {
    return next({ name: 'error-503' })
  }
  // ====================================================================================

  if (!checkAccessible() && to.name !== 'not-accessible') {
    return next({ name: 'not-accessible' })
  }

  if (to.name === 'verification-result') {
    const { retInfo } = to.query

    store.commit('util/setVerifyResult', retInfo)

    return next(false)
  }

  if (to.name === 'login-main') {
    if (router.app.$store.getters['util/getAccess'] === false) return next({ name: 'pw-reset-main' })
  }

  if (to.meta.isAuth) {
    const isLoggedIn = await isUserLoggedIn()

    if (!isLoggedIn) next({ name: 'login-main', query: { redirect: to.name } })
  }

  return next()
})

export default router
